import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileLock: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="file-lock, document">
      <path
        d="M5 10V3H13L19 9V21H14M13 4V9H18M4 17H10V21H4V17ZM9 17V16C9 14.8954 8.10457 14 7 14C5.89543 14 5 14.8954 5 16V17H9Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconFileLock;
